import React, { useState } from 'react';

import SelectedColors from '../types/SelectedColors';
import SelectedParts from '../types/SelectedParts';
import generateRandomSelectedColors from '../utils/generateRandomSelectedColors';
import generateRandomSelectedParts from '../utils/generateRandomSelectedParts';

type PFPGeneratorContextValue = {
  mobileDevicePFPImageDataUri: string;
  setMobileDevicePFPImageDataUri: (value: string) => void;
  selectedParts: SelectedParts;
  setSelectedParts: (selectedParts: SelectedParts) => void;
  selectedColors: SelectedColors;
  setSelectedColors: (selectedColors: SelectedColors) => void;
};

const PFPGeneratorContext = React.createContext<PFPGeneratorContextValue>(null);

export default PFPGeneratorContext;

export const usePFPGeneratorContext = () =>
  React.useContext(PFPGeneratorContext);

export const PFPGeneratorContextProvider = (props) => {
  const [mobileDevicePFPImageDataUri, setMobileDevicePFPImageDataUri] =
    useState<string>();

  const [selectedParts, setSelectedParts] = useState<SelectedParts>(
    generateRandomSelectedParts()
  );

  const [selectedColors, setSelectedColors] = useState<SelectedColors>(
    generateRandomSelectedColors()
  );

  return (
    <PFPGeneratorContext.Provider
      value={{
        mobileDevicePFPImageDataUri,
        setMobileDevicePFPImageDataUri,
        selectedParts,
        setSelectedParts,
        selectedColors,
        setSelectedColors,
      }}
      {...props}
    />
  );
};
